<template>
  <div class="container">
    <van-nav-bar :title="$t('userInfo.title')">
      <template #left>
        <van-icon name="arrow-left" color="#fff" size="20"  @click="back()"></van-icon>
      </template>
    </van-nav-bar>

    <template v-if="accountRows.length">
      <div class="row" v-for="row in accountRows" :key="row.key">
        <div class="title">{{ row.title }}</div>
        <div class="value">{{ row.value }}</div>
      </div>
    </template>
    <div v-else class="empty-card">
      <div class="empty-text">{{ $t("withdraw.account_empty") }}</div>
      <div class="bind-btn" @click="goBind">{{ $t("withdraw.go_bind") }}</div>
    </div>
  </div>
</template>

<script>
import {
  describeWithdrawInfo,
  parseWithdrawInfo,
  resolveWithdrawConfig,
  resolveWithdrawFields
} from '@/common/withdrawForm';

export default {
  data() {
    return {
      withdrawFields: [],
      accountInfo: {}
    };
  },
  computed: {
    accountRows() {
      return describeWithdrawInfo(this.withdrawFields, this.accountInfo);
    }
  },
  methods: {
    back(){
      return window.history.back();
    },
    goBind(){
      this.$router.push('/BindCard');
    },
    getWithdrawConfig(){
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_config'
      }).then(res=>{
        if(res && res.code === 200){
          const config = resolveWithdrawConfig(res);
          this.withdrawFields = resolveWithdrawFields(config);
          this.accountInfo = parseWithdrawInfo(config.account && config.account.withdraw_info);
        }else if(res && res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getWithdrawConfig();
    }
  }
};
</script>

<style lang='less' scoped>
.container{
  min-height: 100%;
  background: linear-gradient(180deg, #fff5f8 0%, #f8f3ff 55%, #fff6f0 100%);
  padding-bottom: 1rem;
}

.van-nav-bar {
  background: linear-gradient(120deg, #f3a3c4 0%, #c3a6f0 55%, #ffb894 100%);
  height: 2.88rem;
  position: relative !important;

  /deep/ .van-nav-bar__title{
    color: #fff;
    font-size: 1rem;
  }
  /deep/ .van-nav-bar__left{
    padding: 0 1rem;
  }
}

.row{
  display: flex;
  width: 92%;
  margin: 0 auto;
  padding: 0.95rem 0.9rem;
  justify-content: space-between;
  align-items: center;
  min-height: 1.5rem;
  box-sizing: border-box;
  position: relative;
  background: #fff;
  border-bottom: 1px solid #f6eef8;
  &:first-of-type {
    margin-top: 0.9rem;
    border-radius: 1.15rem 1.15rem 0 0;
  }
  &:last-of-type {
    border-radius: 0 0 1.15rem 1.15rem;
    border-bottom: none;
    box-shadow: 0 0.4rem 1rem rgba(183, 156, 236, 0.14);
  }
  .title{
    color: #6f6283;
    font-size: 0.88rem;
    flex-shrink: 0;
    margin-right: 1rem;
  }
  .value{
    color: #4a3a5c;
    font-size: 0.88rem;
    font-weight: 600;
    text-align: right;
    word-break: break-all;
  }
}

.empty-card{
  width: 92%;
  margin: 0.9rem auto 0;
  padding: 1.5rem 1rem;
  text-align: center;
  background: #fff;
  border-radius: 1.15rem;
  box-shadow: 0 0.4rem 1rem rgba(183, 156, 236, 0.14);
  .empty-text{
    color: #969799;
    font-size: 0.9rem;
  }
  .bind-btn{
    display: inline-block;
    margin-top: 0.9rem;
    padding: 0.55rem 1.4rem;
    border-radius: 0.9rem;
    color: #fff;
    font-size: 0.88rem;
    background: linear-gradient(120deg, #f7a1c0 0%, #c3a3f2 55%, #ffbe9c 100%);
  }
}
</style>
